module.exports = __webpack_public_path__ + "static/img/4-6.9602193a.png";